import styled from 'styled-components'

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    width: 100%;
`

const Track = styled.div`
    width: 100%;
    height: ${({ $size }) => $size === 'sm' ? '6px' : '10px'};
    background: ${({ theme }) => theme.form.border};
    border-radius: 999px;
    overflow: hidden;
`

const Fill = styled.div`
    height: 100%;
    width: ${({ $pct }) => $pct}%;
    background: ${({ theme }) => theme.btn.primary};
    border-radius: 999px;
    transition: width 0.3s ease;
`

const Label = styled.span`
    font-size: 0.78rem;
    color: ${({ theme }) => theme.font.label};
`

const ProgressTracker = ({ value = 0, total = 0, label, showLabel = true, size = 'md' }) => {
    const pct = total > 0 ? Math.min(100, Math.round((value / total) * 100)) : 0
    const displayLabel = label ?? `${value} / ${total}`

    return (
        <Wrapper>
            <Track $size={size}>
                <Fill $pct={pct} />
            </Track>
            {showLabel && <Label>{displayLabel}</Label>}
        </Wrapper>
    )
}

export default ProgressTracker
